import { css } from '@emotion/react'
import { memo, ReactNode } from 'react'
import { getThemeSpacing } from '../../styles/appTheme'

const titleStyles = css({
    marginRight: getThemeSpacing(),
    whiteSpace: 'nowrap',
    fontWeight: 600,
})

const rowStyles = css({
    display: 'flex',
    alignItems: 'flex-start',
    padding: 0,
    paddingTop: getThemeSpacing(0.5),
    paddingBottom: getThemeSpacing(0.5),
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
    margin: 0,
})

interface IAttributes {
    show?: boolean
    title: string
    value: ReactNode
}
interface ITable {
    rows: Array<IAttributes>
}

const Table = memo((props: ITable) => {
    const { rows = [] } = props
    return (
        <div>
            {rows.map(({ show = true, title, value }) => {
                if (!show) {
                    return null
                }
                const testId = `Typography__${title.replace(/\s/g, '')}`
                return (
                    <div key={title} css={rowStyles}>
                        <span css={titleStyles} data-testid={testId}>
                            {title}:
                        </span>
                        <span>{value}</span>
                    </div>
                )
            })}
        </div>
    )
})

export default Table
